// Theme token strings for use in inline styles and SVG fill/stroke.
export const THEME_COLORS = {
  textPrimary: "var(--confetti-text-primary, #333)",
  textSecondary: "var(--confetti-text-secondary, #666)",
  textTertiary: "var(--confetti-text-tertiary, #949494)",
  textInverse: "var(--confetti-text-inverse, #fff)",

  interactiveDefault: "var(--confetti-interactive-default, #2a5cdb)",

  statusSuccess: "var(--confetti-status-success, #00a861)",
  statusSuccessStrong: "var(--confetti-status-success-strong, #027946)",
  statusError: "var(--confetti-status-error, #f3224d)",
  statusErrorStrong: "var(--confetti-status-error-strong, #d61e44)",
  statusWarning: "var(--confetti-status-warning, #f6be45)",
  statusWarningStrong: "var(--confetti-status-warning-strong, #b37d09)",
  statusInfo: "var(--confetti-status-info, #863dff)",
} as const;
